<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" class="icon">
    <g>
      <path
        d="M48,25C48,12.317,37.683,2,25,2S2,12.317,2,25s10.317,23,23,23S48,37.683,48,25z M24,38V20h-6l7-7l7,7h-6v18H24z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "arrow-up"
};
</script>
<style scoped>
.icon {
  fill: currentColor;
}
</style>
